/**
 * 阿里云缩略图封装 https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.2.2.4d3a4a95sbKPWb
 * @param {String} url 阿里云图片地址
 * @param {Object} options 处理参数
 * @param {String} process 处理方式 默认缩放 resize，其他的还有crop 裁剪 circle 内切圆
 * @return {String}
 */
export function aliyunImageThumb(
  url,
  options = {
    //缩放 resize 参数
    l: null, //指定目标缩略图的最长边。 	1-4096
    s: null, //指定目标缩略图的最短边。 	1-4096
    w: null, //	指定目标缩略图的最长边。   1-4096
    h: null, //指定目标缩略图的高度。      1-4096
    limit: 1, //指定当目标缩略图大于原图时是否处理。值是 1 表示不处理；值是 0 表示处理。 0/1, 默认是 1
    m: "lfit", //指定缩略的模式：  lfit、mfit、fill、pad、fixed，默认为 lfit。
    //             lfit：等比缩放，限制在指定w与h的矩形内的最大图片。
    //             mfit：等比缩放，延伸出指定w与h的矩形框外的最小图片。
    //             fill：固定宽高，将延伸出指定w与h的矩形框外的最小图片进行居中裁剪
    //             pad：固定宽高，缩略填充
    //             fixed：固定宽高，强制缩略
    color: null, //当缩放模式选择为 pad（缩略填充）时，可以选择填充的颜色(默认是白色)参数的填写方式：采用 16 进制颜色码表示，如 00FF00（绿色）。
    p: null, //倍数百分比。 小于 100，即是缩小，大于 100 即是放大。 	1-1000

    //裁剪 crop参数
    // w: null,//指定裁剪宽度
    // h: null,//指定裁剪高度
    x: null, //指定裁剪起点横坐标（默认左上角为原点）
    y: null, //定裁剪起点纵坐标（默认左上角为原点）
    g: null, //设置裁剪的原点位置，由九宫格的格式，一共有九个地方可以设置，每个位置位于每个九宫格的左上角 nw, north, ne, west, center, east, sw, south, se

    //内切圆 circle
    r: null, //从图片取出的圆形区域的半径
  },
  process = "resize"
) {
  let { l, s, w, h, limit, m, color, p, x, y, g, r } = options;
  if (l) {
    l = uni.upx2px(l * 2);
  }
  if (s) {
    s = uni.upx2px(s * 2);
  }
  if (w) {
    w = uni.upx2px(w * 2);
  }
  if (h) {
    h = uni.upx2px(h * 2);
  }
  if (limit) {
    limit = limit;
  }
  if (m) {
    m = m;
  }
  let result = "";
  result =
    url +
    "?x-oss-process=image/" +
    process +
    (l ? ",l_" + l : "") +
    (s ? ",s_" + s : "") +
    (w ? ",w_" + w : "") +
    (h ? ",h_" + h : "") +
    (limit ? ",limit_" + limit : "") +
    (m ? ",m_" + m : "") +
    (color ? ",color_" + color : "") +
    (p ? ",p_" + p : "") +
    (x ? ",x_" + x : "") +
    (y ? ",y_" + y : "") +
    (g ? ",g_" + g : "") +
    (r ? ",r_" + r : "");
  return result;
}

// 这个跨域了 不能用
export async function aliyunImageInfo(url) {
  const uri = url + "?x-oss-process=image/info";
  const [error, result] = await uni.request({
    url: uri,
  });
  return result;
}
